<template>
  <section id="main-destination" class="container-fluid exp-mt exp-mb" v-if="destinations.length > 0">
    <div class="row col-lg-10 destination-content">
      <div class="col-lg-12 text-center">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <h2 class="destinations-hd">{{ experienceType }}</h2>
          <div v-html="experienceDescription"></div>
        </div>
      </div>
      <div class="destination-container left-column row col-lg-4 desktop-display">
        <router-link :to="'' + destination.url" v-for="(destination, index) in destinations.slice(0, 2)" :key="index" class="destination">
          <figure class="destination-image">
            <b-img-lazy :src="destination.imageurl" :alt="destination.image_alt_text" class="img-fluid img-mobile-radius" />
          </figure>
          <div class="destination-box left">
            <h3 class="destination-name">{{ destination.name }}</h3>
            <div class="destination-link">Find Out More</div>
          </div>
        </router-link>
      </div>
      <div class="destination-container middle-column row col-lg-4 desktop-display">
        <router-link :to="'' + destination.url" v-for="(destination, index) in destinations.slice(2, 4)" :key="index" class="destination">
          <figure class="destination-image">
            <b-img-lazy :src="destination.imageurl" :alt="destination.image_alt_text" class="img-fluid img-mobile-radius" />
          </figure>
          <div class="destination-box middle">
            <h3 class="destination-name">{{ destination.name }}</h3>
            <div class="destination-link">Find Out More</div>
          </div>
        </router-link>
      </div>
      <div class="destination-container right-column row col-lg-4 desktop-display">
        <router-link :to="'' + destination.url" v-for="(destination, index) in destinations.slice(4, 6)" :key="index" class="destination">
          <figure class="destination-image">
            <b-img-lazy :src="destination.imageurl" :alt="destination.image_alt_text" class="img-fluid img-mobile-radius" />
          </figure>
          <div class="destination-box right">
            <h3 class="destination-name">{{ destination.name }}</h3>
            <div class="destination-link">Find Out More</div>
          </div>
        </router-link>
      </div>
      <div class="destination-container row mobile-display">
        <div v-for="(destination, index) in destinations.slice(0, 6)" :key="index" class="destination-mobile">
          <figure class="destination-image-mobile">
            <b-img-lazy :src="destination.imageurl" :alt="destination.image_alt_text" class="img-fluid img-mobile-radius" />
          </figure>
          <div class="destination-box-mobile">
            <h3 class="destination-name">{{ destination.name }}</h3>
            <router-link :to="'' + destination.url" class="destination-link">Find Out More</router-link>
          </div>
        </div>
      </div>
    </div>
    <router-link class="button" :to="'' + buttonLink">{{ buttonText }}</router-link>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  data() {
    return {};
  },
})
class ExperienceDestinations extends Vue {
  @Prop({
    type: [String],
    required: true,
  })
  slug;

  @Prop({
    type: [String],
    required: true,
  })
  experienceType;

  @Prop({ type: [String] })
  experienceDescription;

  @Prop({
    type: [Array],
    required: true,
  })
  destinations;

  @Prop({
    type: [String],
    required: true,
  })
  mapDestinationType;

  @Prop({
    type: [String],
    required: true,
  })
  destinationBackgroundImageUrl;

  @Prop({
    type: [String],
  })
  buttonText;

  @Prop({
    type: [String],
    required: true,
  })
  buttonLink;
}

export default ExperienceDestinations;
</script>

<style scoped>
h2 {
  color: #173945;
  line-height: 40px;
}

.button {
  background: transparent;
  border: 2px solid #173945;
  color: #173945;
  padding: 15px 75px 10px 65px;
}

.exp-mb {
  margin-bottom: 120px;
}

.exp-mt {
  margin-top: 120px;
}

a.router-link-active:hover {
  color: #ffffff;
  text-decoration: underline;
}

.destinations-hd {
  margin: 20px 20px 0 20px;
}

.destination-name {
  color: #ffffff;
}

.destination-link {
  color: #fff;
  font-size: 16px;
  text-decoration: underline;
}

.destination-link:hover {
  text-decoration: none;
}

.destination-content {
  min-height: 500px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: auto;
  margin-right: auto;
}

.destination-container {
  margin: 0;
  padding-top: 10px;
  padding-bottom: 30px;
}

.destination-container.left-column {
  margin-bottom: 200px;
}

.destination-container.middle-column {
  margin-top: 160px;
}

.destination-container.right-column {
  margin-bottom: 150px;
  margin-top: 50px;
}

.destination {
  position: relative;
  width: 100%;
}

.destination-mobile {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;
  margin-right: auto;
  margin-left: auto;
  text-align: left;
}

.destination-image {
  border-radius: 4px;
  margin-bottom: 60px;
  margin-left: 40px;
  margin-top: 60px;
  overflow: hidden;
  width: 80%;
}

.destination-box {
  background-color: #173945;
  box-shadow: 0 0 1px 0 rgb(10 22 70 / 6%), 0 6px 6px -1px rgb(10 22 70 / 10%);
  transition: all 0.3s ease-in-out;
  width: 250px;
  height: auto;
  position: absolute;
  padding: 25px;
  margin-left: auto;
  margin-right: auto;
}

.destination-box:hover {
  box-shadow: 0 0 1px 0 rgb(10 22 70 / 6%), 0 16px 26px -1px rgb(10 22 70 / 10%);
  transition: all 0.3s ease-in-out;
}

.destination-box.left {
  bottom: 0;
  right: 0px;
}

.destination-box.middle {
  top: 0;
  right: 0px;
}

.destination-box.right {
  bottom: 0;
  left: 0px;
}

.locations-map-icon {
  margin: 0px auto;
  max-height: 100px;
}

.mobile-display {
  display: none;
}

@media only screen and (max-width: 768px) {
  .destination-container.left-column,
  .destination-container.middle-column,
  .destination-container.right-column {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .destination-image {
    border-radius: 4px;
  }
}

@media only screen and (max-width: 414px) {
  .mobile-display {
    display: block;
  }

  .desktop-display {
    display: none;
  }

  .destination-box-mobile {
    background-color: #173945;
    height: auto;
    padding: 25px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    box-shadow: 0 0 1px 0 rgb(10 22 70 / 6%), 0 6px 6px -1px rgb(10 22 70 / 10%);
  }

  .destination-image-mobile {
    margin-bottom: 0px;
    margin-top: 0px;
    width: 100%;
  }

  .img-mobile-radius {
    border-radius: 4px;
  }
}
</style>
